import React, { useEffect, useRef, useState } from 'react';
import {TransportCompaniesScreen} from '../screens/transportation-companies/ui/screens/TransportCompaniesScreen';
export default function ShipperConfiguration() {

    return (
        <div>
           <TransportCompaniesScreen></TransportCompaniesScreen>
        </div>
    );
}